import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { BASE_URL } from "../../config.json";
import ENUMS from "../../utils/ENUMS";
import { useHistory } from "react-router-dom";
import "./CourseDetailsRenew.css";

const AddedCoursesCard = () => {
  const [courseData, setCourseData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [courseIdToDelete, setCourseIdToDelete] = useState(null);
  const token = localStorage.getItem(ENUMS.AUTH);
  const history = useHistory();

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = () => {
    axios
      .get(`${BASE_URL}/club/course/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setCourseData(res.data.data || []);
      })
      .catch((err) => console.error(err));
  };

  const handleDelete = () => {
    axios
      .delete(`${BASE_URL}/club/course/`, {
        headers: { Authorization: `Bearer ${token}` },
        data: { golf_course_id: courseIdToDelete },
      })
      .then((res) => {
        if (res.status === 200) {
          toast.success("Course deleted successfully");
          fetchCourses();
          setShowModal(false);
        } else {
          toast.error("Failed to delete course");
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Something went wrong");
      });
  };

  return (
    <Fragment>
      <ToastContainer />
      <div className="added-courses-container"> 
      <div className="progress_bar">
              <ul className="progress_bar__row ">
                <li className="text-jost-sb-22 completed">CLUB Details</li>
                <li className="text-jost-sb-22 active">Golf Courses</li>
                <li className="text-jost-sb-22">Payment DETAILS</li>
                <li className="text-jost-sb-22">Confirmation</li>
              </ul>
            </div>

            <h2 className="text-jost-sb-22">
Your clubs golf courses
            </h2>
        {courseData.length === 0 ? (
          <p>No courses found.</p>
        ) : (
          courseData.map((item) => (
<div className="gCourses__box" key={item.id} style={{ display: 'flex', flexDirection: 'row' }}>
              <div className="course-name-pill">
                <h4 className="pill-text">{item.course_name}</h4>
              </div>

               <div className="course-spacer" /> {/* pushes the delete button to the edge */}

    <div className="course-action">
      <button
        className="btn-delete"
        onClick={() => {
          setCourseIdToDelete(item.id);
          setShowModal(true);
        }}
      >
        Delete
      </button>
    </div>
            </div>
          ))
        )}

        <div className="payment-button-row">
          <button
            className="res-btn-primary"
            onClick={() => history.push("/golf-pay")}
          >
            Payment
          </button>
        </div>

        {showModal && (
          <div className="modal-overlay">
            <div className="modal-box">
              <button className="modal-close" onClick={() => setShowModal(false)}>
                &times;
              </button>
              <h4 className="modal-title">
                Are you sure you want to delete this course?
              </h4>
              <div>
                <button
                  className="btn-cancel"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button className="btn-confirm" onClick={handleDelete}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default AddedCoursesCard;
